import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
const Recaptcha = require('react-recaptcha');
import { closePopup,hideModalHeader } from '../../Modal/action';
import Input from "../../Input/index";
import './style.scss'
import {formDataGenerator, getLang} from "../../../../../utils/common";
import {SuccessFailure} from "../SuccessFailure";

@connect((state)=>({
    subscribeResult: state.product.productList.subscribeResult,
}),(dispatch)=>({
    ...bindActionCreators({hideModalHeader},dispatch),
}))
export default class Subscribe extends Component {

    constructor(props){
        super(props);
        this.state={
            email : '',
            captchaToken: '',
            error: '',
            captchaTokenError:'',
        }
    }

    componentWillReceiveProps(nextProps){
        let {subscribeResult} = nextProps, error;
        error = subscribeResult && !subscribeResult.status ? subscribeResult.message : '';
        error && this.setState({error:error});
    }

    validateEmail=(name,value)=>{
        return /^\w+([-+.']\w+)*@[A-Za-z\d]+\.com$|.in$/.test(value)
        ? '' : 'incorrect email';         
    }

    onChange=(name,value)=>{
        let errorMessage = this.validateEmail(name,value),
        state = this.state.error !== errorMessage ? {[name]:value,error: errorMessage} : {[name]:value}
        this.setState(state);
    }

    getFormData=()=>{
        let {isProduct} = this.props;
        let data;
        if(isProduct){
              data={
                product: this.props.itemId,
                email: this.state.email,
                captchaToken: this.state.captchaToken
            };
        }
        else {
              data={
                schemes: this.props.itemId.toString(),
                email: this.state.email,
                captchaToken: this.state.captchaToken
            };
        }
        //debugger
        return formDataGenerator(data);
    }

    // specifying verify callback function
    verifyCallback = (response) =>{
        let {captchaToken} = this.state;
        this.setState({captchaToken:response});
        this.setState({captchaTokenError:""});
        // console.log(response);
    };

    onSubmit=async()=>{

        let {captchaToken, captchaTokenError} = this.state;

        if(captchaToken){
            let {subscribe,hideModalHeader , isProduct} = this.props;
            isProduct ? subscribe && await subscribe(getLang(),this.getFormData(),true):
                subscribe && await subscribe(getLang(),this.getFormData(),false);
            const {subscribeResult}=this.props;
            (subscribeResult && subscribeResult.status) && hideModalHeader();
        }else{
            this.setState({
                captchaTokenError:"* Please validate that you are not robot."
            })
        }
        
    }

    render() {
        let { closePopup, subscribeResult, afterPopupClose,isProduct } = this.props,
            { email, captchaToken, error,captchaTokenError } = this.state,
            disabled = email ? error : true,
            successMessage = subscribeResult &&  subscribeResult.status && subscribeResult.message;
               return (
            <div className="modal-body">
                        {!subscribeResult ||  !subscribeResult.status  ? <div>
                                <Input name='email' value={this.state.email}
                                       required={true}
                                       labelName="Email id"
                                       errorMessage={this.state.error} 
                                       onChange={this.onChange} />
                                 <Recaptcha
                                    ref={e => this.recaptchaInstance = e}
                                    sitekey="6LcKVAsUAAAAAFIptnZfbQ35CNbQdYI4YOW40tuX"
                                    render="explicit"
                                    verifyCallback={this.verifyCallback}
                                />
                                <div className='text-start captchaerror'>{captchaTokenError}</div>
                                <button className='btn-primary' disabled={disabled} onClick={this.onSubmit}>SUBMIT</button>
                        </div> : subscribeResult.status && <SuccessFailure message={successMessage} closePopup={closePopup}
                                                 afterPopupClose={afterPopupClose} />}
                  </div>
        );
    }
}

